import { CommonModule } from '../store/module/common'
import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

let msgInstance: any = null
export const myMsg = (options: any) => {
  if (msgInstance) {
    msgInstance.close()
  }
  msgInstance = Message(options)
}

// 根据当前环境，设置 baseURL 参数。当 NODE_ENV 为 development 时不需要加前缀，而非 development 环境时需要加前缀
// 因此 api 下文件不需要再加接口前缀
// 同时设置统一前缀VUE_APP_PROXY_PREFIX，并且在vue.config中通过pathrewrite还原，可避免重复写proxy😏
// 可以在.env.development文件中修改
const { NODE_ENV, VUE_APP_PROXY_PREFIX, VUE_APP_BASE_URL } = process.env
const baseURL = NODE_ENV === 'development' ? VUE_APP_PROXY_PREFIX : VUE_APP_BASE_URL
const service = axios.create({
  baseURL
})

enum EResCode {
  SUCCESS = 200, // 接口请求成功
  FAIL = 10500, // 接口请求失败
  NOTLOGIN = 302, // 没有登录
  LOGINEXPIRED = 402, // 登录信息过期
  VAILDCODE = 401, // 验证码错误
  PARAMSERROR = 10002, // 请求参数有误
  WITHOUTAUTH = 10400 // 没有权限
}

service.interceptors.request.use(
  (config: any) => {
    config.withCredentials = true
    config.timeout = 35000
    config.headers = Object.assign(config.headers, {
      // 增加登录token，用于校验登录token是否过期
      // Authorization: getToken()
      // 'Content-type': '	application/x-www-form-urlencoded'
    })
    CommonModule.SHOW_LOADING(true)
    return config
  },
  (err: any) => {
    CommonModule.SHOW_LOADING(false)
    return Promise.reject(err)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  (response: any) => {
    CommonModule.SHOW_LOADING(false)
    const { status } = response
    const code = response.data.code
    if (status === 200) {
      switch (code) {
        case EResCode.SUCCESS:
          return response.data
        case EResCode.FAIL:
          throw response.data
        case EResCode.NOTLOGIN:
          // myMsg({
          //   message: response.data.msg || '未登录，请先登录',
          //   type: 'error',
          //   duration: 2000
          // })
          throw response.data
        case EResCode.LOGINEXPIRED:
          if (response.config.url !== '/account/GetCurrentInfo') {
            myMsg({
              message: response.data.msg || '登录过期，请重新登录',
              type: 'error',
              duration: 2000,
              onClose: function () {
                router.push('/login')
              }
            })
          } else {
            router.push('/login')
          }
          break
        case EResCode.WITHOUTAUTH:
          myMsg({
            message: '无权访问',
            type: 'error',
            duration: 2000,
            onClose: function () {
              router.go(-1)
            }
          })
          break
        default:
          throw response.data
      }
    }
  },
  (err: any) => {
    CommonModule.SHOW_LOADING(false)
    if (err.request) {
      myMsg({
        message: '网络异常，请刷新重试',
        type: 'error',
        duration: 2000
      })
    } else if (err.response) {
      const errData = err.response
      if (('' + errData.status).startsWith('5')) {
        myMsg({
          message: '网络请求错误，请刷新重试',
          type: 'error',
          duration: 2000
        })
      }
    }
    throw err
  }
)

export default service
